<template>
  <b-form-checkbox class="profile-active-switch" switch v-model="value" @change="handleClick"></b-form-checkbox>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: 'slicing-profile-enable-switcher',
    props: ['enabled', 'profileId', 'profileName'],
    data() {
      return {
        value: false
      }
    },
    created() {
      this.value = this.enabled;
    },
    methods: {
      ...mapActions(['updateProfileEnableState']),

      handleClick() {
        const action = this.enabled ? "disable" : "enable";

        this.updateProfileEnableState({profileId: this.profileId, enabled: !this.enabled}).then(data => {
          if (!data.result) {
            this.value = this.enabled;
            this.msgBoxOk(data.message, {title: 'Failed to ' + action + 'profile'});
          }
        }).catch(() => {
          this.value = this.enabled;
        });
      }
    },
    watch: {
      enabled: function(val) {
        this.value = val;
      }
    }
  }
</script>